import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/agendar`

    return {
        create() {
            return repository.get(`${baseUrl}/create`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        editHorario() {
            return repository.get(`${baseUrl}/alterar-horario`)
        },
        updateHorario(params) {
            return repository.put(`${baseUrl}/alterar-horario`, params)
        },
        update(params) {
            return repository.put(`${baseUrl}/alterar-agendado`, params)
        },
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        show(id) {
            return repository.get(`${baseUrl}/${id}`)
        },
        getDestinos(queryParms = {}) {
            return repository.get(`${baseUrl}/destino?${urlUtil.serialize(queryParms)}`)
        },
        getPontos(id) {
            return repository.get(`${baseUrl}/ponto/${id}`)
        },
        getVeiculos(queryParms = {}) {
            return repository.get(`${baseUrl}/veiculo?${urlUtil.serialize(queryParms)}`)
        },
        getJornadas(queryParms = {}) {
            return repository.get(`${baseUrl}/jornada?${urlUtil.serialize(queryParms)}`)
        },
        getAgendados(queryParms = {}) {
            return repository.get(`${baseUrl}/agendado?${urlUtil.serialize(queryParms)}`)
        },
        getAgendadosPaciente(queryParms = {}) {
            return repository.get(`${baseUrl}/agendado-paciente?${urlUtil.serialize(queryParms)}`)
        },
        getMunicipios(queryParms = {}) {
            return repository.get(`${baseUrl}/municipios?${urlUtil.serialize(queryParms)}`)
        },
        getLocais(queryParms = {}) {
            return repository.get(`${baseUrl}/locais?${urlUtil.serialize(queryParms)}`)
        },
        getHorarios(queryParms = {}) {
            return repository.get(`${baseUrl}/horarios?${urlUtil.serialize(queryParms)}`)
        },
        getAgendamentos(queryParms = {}) {
            return repository.get(`${baseUrl}/agendamentos?${urlUtil.serialize(queryParms)}`)
        },
        getFaltasPaciente(queryParms = {}) {
            return repository.get(`${baseUrl}/falta-paciente?${urlUtil.serialize(queryParms)}`)
        },
        salvarObservacao(params) {
            return repository.post(`${baseUrl}/observacao`, params)
        },
        getHistoricos(id) {
            return repository.get(`${baseUrl}/historico/${id}`)
        },
        getTiposPassageiros(queryParms = {}) {
            return repository.get(`${baseUrl}/tipo-passageiros?${urlUtil.serialize(queryParms)}`)
        },
    }
}